window.$ = jQuery;

const Staff = (function() {
    $(".staff-section__staff__member .staff-section__staff__member__info__read-more").on("click", function(e) {
        $(this).parents(".staff-section__staff__member").toggleClass("toggled");
    });
})();

export default Staff;